import { render } from "./DevicePosition.vue?vue&type=template&id=2d1c06e6&scoped=true"
import script from "./DevicePosition.vue?vue&type=script&lang=js"
export * from "./DevicePosition.vue?vue&type=script&lang=js"

import "./DevicePosition.vue?vue&type=style&index=0&id=2d1c06e6&scoped=true&lang=css"

import exportComponent from "C:\\All Projects\\Digital Sinage Main\\Digital Sinage Admin\\media-device-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d1c06e6"]])

export default __exports__